module.exports = __webpack_public_path__ + "static/media/img29-4.1a877fed.jpg";